import { ToastContainer } from "react-toastify";
import Home from "./Routes/Home";
import * as Sentry from "@sentry/react";
import './i18n';

const App = () => {
  return (
    <>
      <Sentry.ErrorBoundary fallback={<p>Something went wrong!</p>}>
        <ToastContainer />
        <Home />
        {/* <button
          onClick={() => {
            throw new Error("This is your first error!");
          }}
        >
          Break the world
        </button> */}
      </Sentry.ErrorBoundary >
    </>
  );
};

export default App;
  